var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "结算",
        maskClosable: false,
        width: "460px",
        confirmLoading: _vm.loading,
        okText: _vm.okText,
        cancelText: "取消",
        footer: _vm.qrShowing ? null : undefined,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "div",
        { staticClass: "pay-body" },
        [
          _vm.qrShowing
            ? [
                _c("div", { staticClass: "pay-total" }, [
                  _vm._v("\n        收款金额：¥"),
                  _c("span", { staticClass: "pay-total-num" }, [
                    _vm._v(_vm._s(_vm.format(_vm.payable))),
                  ]),
                ]),
                _c("div", { staticClass: "qr-box" }, [
                  _vm.qrBase64
                    ? _c("img", {
                        staticClass: "qr-img",
                        attrs: {
                          src: "data:image/png;base64," + _vm.qrBase64,
                          alt: "收款码",
                        },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "qr-tip" }, [
                    _vm._v(
                      _vm._s(
                        _vm.qrExpired
                          ? "收款码已超时，请重新生成"
                          : "请顾客使用微信/支付宝扫码支付"
                      )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "qr-actions" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.emitCreateQrcode },
                        },
                        [_vm._v("重新生成")]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleCancel },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : [
                _c("div", { staticClass: "pay-total" }, [
                  _vm._v("\n        应收金额：¥"),
                  _c("span", { staticClass: "pay-total-num" }, [
                    _vm._v(_vm._s(_vm.format(_vm.payable))),
                  ]),
                ]),
                _c("div", { staticClass: "pay-row" }, [
                  _c("span", { staticClass: "pay-label" }, [
                    _vm._v("支付方式："),
                  ]),
                  _c(
                    "div",
                    { staticClass: "pay-types" },
                    _vm._l(_vm.payOptions, function (type) {
                      return _c(
                        "div",
                        {
                          key: type,
                          staticClass: "pay-type",
                          class: { active: _vm.payTypes.includes(type) },
                          on: {
                            click: function ($event) {
                              return _vm.toggleType(type)
                            },
                          },
                        },
                        [_vm._v(_vm._s(type))]
                      )
                    }),
                    0
                  ),
                ]),
                _vm.singleOnline
                  ? [
                      _c("div", { staticClass: "pay-row" }, [
                        _c("span", { staticClass: "pay-label" }, [
                          _vm._v("收款模式："),
                        ]),
                        _c("div", { staticClass: "pay-types" }, [
                          _c(
                            "div",
                            {
                              staticClass: "pay-type",
                              class: { active: _vm.payMode === "bar" },
                              on: {
                                click: function ($event) {
                                  _vm.payMode = "bar"
                                },
                              },
                            },
                            [_vm._v("付款码支付")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "pay-type",
                              class: { active: _vm.payMode === "qrcode" },
                              on: {
                                click: function ($event) {
                                  _vm.payMode = "qrcode"
                                },
                              },
                            },
                            [_vm._v("扫码收款")]
                          ),
                        ]),
                      ]),
                      _vm.payMode === "bar"
                        ? _c(
                            "div",
                            { staticClass: "pay-row" },
                            [
                              _c("span", { staticClass: "pay-label" }, [
                                _vm._v("顾客付款码："),
                              ]),
                              _c("a-input", {
                                ref: "authInput",
                                staticStyle: { width: "220px" },
                                attrs: { placeholder: "扫码枪录入后自动支付" },
                                on: { pressEnter: _vm.submitBar },
                                model: {
                                  value: _vm.authCode,
                                  callback: function ($$v) {
                                    _vm.authCode = $$v
                                  },
                                  expression: "authCode",
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", { staticClass: "pay-row pay-mode-tip" }, [
                            _c("span", { staticClass: "pay-sub" }, [
                              _vm._v(
                                "点击「生成收款码」后请顾客扫码支付，支付完成自动结算"
                              ),
                            ]),
                          ]),
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "pay-row" },
                  [
                    _c("span", { staticClass: "pay-label" }, [
                      _vm._v("抹零金额："),
                    ]),
                    _c("a-input-number", {
                      staticStyle: { width: "140px" },
                      attrs: { min: 0, max: _vm.total, precision: 2 },
                      model: {
                        value: _vm.eraseAmount,
                        callback: function ($$v) {
                          _vm.eraseAmount = $$v
                        },
                        expression: "eraseAmount",
                      },
                    }),
                    _c("span", { staticClass: "pay-sub" }, [
                      _vm._v("（可选，分位抹零）"),
                    ]),
                  ],
                  1
                ),
                _vm.payTypes.includes("现金")
                  ? _c(
                      "div",
                      { staticClass: "pay-row" },
                      [
                        _c("span", { staticClass: "pay-label" }, [
                          _vm._v("现金收款："),
                        ]),
                        _c("a-input-number", {
                          staticStyle: { width: "140px" },
                          attrs: {
                            min: 0,
                            precision: 2,
                            placeholder: "实收现金",
                          },
                          model: {
                            value: _vm.cashReceived,
                            callback: function ($$v) {
                              _vm.cashReceived = $$v
                            },
                            expression: "cashReceived",
                          },
                        }),
                        _vm.cashReceived > 0
                          ? _c("span", { staticClass: "pay-sub" }, [
                              _vm._v(
                                "找零：¥" +
                                  _vm._s(
                                    _vm.format(
                                      Math.max(
                                        0,
                                        _vm.cashReceived - _vm.payable
                                      )
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "pay-row" },
                  [
                    _c("span", { staticClass: "pay-label" }, [
                      _vm._v("需要发票："),
                    ]),
                    _c("a-checkbox", {
                      attrs: { checked: _vm.needInvoice },
                      on: {
                        change: (e) => (_vm.needInvoice = e.target.checked),
                      },
                    }),
                    _vm.needInvoice
                      ? [
                          _c("a-input", {
                            staticStyle: {
                              width: "180px",
                              "margin-left": "8px",
                            },
                            attrs: { placeholder: "发票抬头" },
                            model: {
                              value: _vm.invoiceTitle,
                              callback: function ($$v) {
                                _vm.invoiceTitle = $$v
                              },
                              expression: "invoiceTitle",
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }